import DriveEndType from "../../enums/drive-end-type";
import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";
import { isSeriesOvertime } from "../../utils/overtime-utils";

export default class NextKickOff extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const skipKickoff = play.historyContains(FootballState.SkipKickoff);
        if (skipKickoff) return false;

        // PAT plays always trigger next kickoff (even in OT)
        if (ruleContext.PAT) return true;

        // Change-of-possession drive ends (a turnover or a punt) hand the ball
        // straight to the other team — no kickoff follows. A punt is now
        // classified as DriveEndType.Punt (was lumped under Turnover), so it
        // must be excluded here too.
        //
        // Read the end type off gameContext, not play.contextSnapshot: the
        // snapshot holds how the *previous* drive ended (i.e. how the current
        // drive started), so a drive that began with a turnover/punt and ended
        // with a made field goal or a safety was wrongly denied its kickoff.
        // The drive-end rules (Turnover, FieldGoalGood, Safety, PeriodStart)
        // all run before ResetField, so gameContext already carries how the
        // drive that just ended, ended — including Halftime, which is why the
        // PSTATS-1052 halftime special case is no longer needed.
        const noKickoffEndTypes = [
            DriveEndType.Turnover.code,
            DriveEndType.Punt.code
        ];

        // Series overtime has no kickoffs apart from the one after a try
        // (above); with OT Kickoffs on, overtime kicks off as regulation
        // does (PSTATS-1268).
        return (
            !noKickoffEndTypes.includes(
                gameContext.driveContext?.previousDriveEndType?.code
            ) && !isSeriesOvertime(gameContext)
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const spot = ruleContext.isSafety
            ? gameContext.gameConfig.spots.safetyKO
            : gameContext.gameConfig.spots.kickoff;

        let fieldPosition = !gameContext.homeTeamHasPossession
            ? gameContext.getFieldLength() - spot
            : spot;

        gameContext.triggerKO = true;
        gameContext.setFieldPosition(fieldPosition);
    }
}
